// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__27HuB","containerItemsCenter":"Skeleton_containerItemsCenter__Zcopi"};